import { createMachine, assign } from "xstate";
import { imageUploaderMachine } from "../../ImageUpload/machines/uploadMachine";
import { Assets } from "../../ImageUpload/machines/config/types";

const IMAGE_MINIMUM = 6;

const respondOrError = (response) => {
  if (response.status === 404) throw new Error("Not Found");
  return response.json();
};

const fetchSurvey = (id: number) =>
  fetch(`/api/v1/surveys/${id}`).then(respondOrError);

const fetchAssets = (survey_id: number) =>
  fetch(`/api/v1/surveys/${survey_id}/images`).then(respondOrError);

export default createMachine(
  {
    id: "orderer",
    initial: "init",
    context: {
      id: null,
      survey: null,
      orderId: null,
      images: {},
    },
    states: {
      init: {
        always: [
          {
            target: "sources",
            guard: "isNotExisting",
          },
          { target: "loading" },
        ],
      },
      sources: {
        initial: "loading",
        invoke: {
          id: "getSurvey",
          src: "getSurvey",
          onDone: {
            target: "#orderer.loading",
            actions: assign({
              survey: (context, event) => event.data.data.survey,
            }),
          },
        },
        states: {
          loading: {},
        },
      },
      loading: {
        invoke: {
          id: "getAssets",
          src: "getAssets",
          onDone: {
            target: "check",
            actions: "splitAssets",
          },
          onError: {
            target: "failure",
          },
        },
      },
      failure: {},
      check: {
        always: [
          {
            target: "images",
          },
        ],
      },
      images: {
        initial: "ready",
        invoke: {
          id: "imageUploader",
          src: "imageUploaderMachine",
          onDone: {
            actions: "imagesToUploader",
            target: ".complete",
          },
          data: (context) => ({
            surveyId: context.id,
            orderId: context.orderId,
            images: context.images,
            files: [],
            adding: {
              added: 0,
              total: 0,
            },
            autoComplete: true,
          }),
        },
        states: {
          ready: {},
          complete: {},
        },
      },
      status: {},
    },
    on: {
      CHANGE_NAME: {
        actions: assign({ name: (context, event) => event.name }),
      },
      STATUS: ".status",
    },
  },
  {
    guards: {
      isNotExisting: (context) =>
        context.id === null || context.survey === null,
      isIncomplete: (context) => false,
      isComplete: (context) => {
        const images = Object.values(context.images);
        return (
          images.length >= IMAGE_MINIMUM &&
          images.every((image) => image.uploaded)
        );
      },
      isSubmitted: (context) => false,
    },
    actions: {
      splitAssets: assign((context, event) => {
        const images: Assets = {};
        const documents: Assets = {};

        for (const asset of event.data) {
          /*
              TODO: This won't work if people upload jpeg with exif as documents.
              
              1. Could add a flag into the db table to be very specific that these are mapping inputs
              2. Could prevent the uploading of jpegs with exif data as documents
          */
          if (asset.mimetype === "image/jpeg" && asset.exif) {
            images[asset.uid] = asset;
          } else {
            documents[asset.uid] = asset;
          }
        }

        return { images, documents };
      }),
      imagesToUploader: assign({
        images: (context, event) => ({
          ...context.images,
          ...event.data.images,
        }),
      }),
    },
    services: {
      getSurvey: (context, event) => fetchSurvey(context.id),
      getAssets: (context, event) => fetchAssets(context.id),
      imageUploaderMachine,
    },
  }
);
